import { KeyValuePipe } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatOptionModule } from '@angular/material/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { VariableType } from '../Models/Enums/variable-type';
import { VariableElement } from '../Models/variable-element';
import { VariableFormDialogData } from '../Models/variable-form-dialog-data';
import { VariableFormDialogResult } from '../Models/variable-form-dialog-result';

@Component({
    selector: 'app-variable-form-dialog',
    imports: [MatCardModule, FormsModule, MatFormFieldModule, MatButtonModule, MatInputModule, MatSelectModule, MatOptionModule, KeyValuePipe],
    templateUrl: './variable-form-dialog.component.html',
    styleUrl: './variable-form-dialog.component.scss'
})
export class VariableFormDialogComponent {
    public item: VariableElement;
    public title: string;

    public variableTypes: Map<VariableType, string> = new Map<VariableType, string>();

    /**
     * Valeur indiquant si le menu contextuel est visible.
     */
    isContextMenuVisible: boolean;

    constructor(
        public dialogRef: MatDialogRef<VariableFormDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private data: VariableFormDialogData
    ) {
        this.item = { ...data.item };
        this.title = data.title;

        this.variableTypes.set(VariableType.Regex, 'Expression Régulière');
        this.variableTypes.set(VariableType.JsonPath, 'Chemin JSON');
        this.variableTypes.set(VariableType.FixedValue, 'Valeur fixe');
    }

    onConfirm(): void {
        let result: VariableFormDialogResult = { status: true, item: this.item };

        // Close the dialog, return true
        this.dialogRef.close(result);
    }

    onCancel(): void {
        let result: VariableFormDialogResult = { status: false, item: this.item };
        // Close the dialog, return false
        this.dialogRef.close(result);
    }
}
